import { Injectable } from '@angular/core';

import { contasContabeisRouter } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { contasRoute } from "../../shared/data.service";

@Injectable()
export class ContaContabilNavigationService {
  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = contasRoute + '/' + contasContabeisRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = contasRoute + '/' + contasContabeisRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = contasRoute + '/' + contasContabeisRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/conta-contabil-navigation.service.ts
 **/